import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useRef } from "react";
import { useGlobalContext } from "../../context/global";
import { isPlatformMatch } from "../../helper/Reports/common";
import {
  getSearchParamsObject,
  formatDate,
  getComparisonFormatTimeDimension,
  getCustomReportKeyByPage,
  saveCustomReportByKey,
  updateCustomReportById,
} from "../../components/Reports/Components/utils";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import {
  defaultDimensions,
  mergeCustomOutputToAPIFiltersFormat,
  reverseMergeAPIFiltersToFilterModuleFormat,
  ruleItemInjector,
  transformToTopXArray,
} from "../../helper/Quadrant/quadrantHelper";
import {
  PlatformWiseKeyMapper,
  PlatformWiseQueryOrder,
} from "../../components/Filter/FilterData/quadrantFilter";
import { processFields } from "../../components/Filter/subComponents/filterHelper";
import CustomPagination from "../../components/CustomPagination/CustomPagination";
import ComplexFilterWidget from "../../components/Filter/ComplexFilterWidget";
import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Badge,
  Box,
  FormControl,
  FormControlLabel,
  CircularProgress,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  ToggleButton,
  Tooltip,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {
  ArrowDropDown,
  ArrowDropUp,
  FilterAlt,
  FilterAltOutlined,
  FileDownloadOutlined,
} from "@mui/icons-material";
import { handleDownloadAllProductData } from "../../components/Reports/Components/ProductAnalyticsDownload";
import ProductAnalyticsTable from "../productReport/ProductAnalyticsTable/ProductAnalyticsTable";
import {
  getPerformanceAllColumns,
  PerformanceAnalysisGroupByOptions,
  PerformanceAnalysisMeasures,
  TIME_LEVEL_DIMENSIONS,
} from "./performanceAnalysisConfigs";
import { FiltersCampaignDataPerformance, FiltersDimensionDataPerformance, FiltersMeasuresDataPerformance, useTopXDataPerformanceConfig } from "./performanceAnalysisFilterConfig";
import AppliedFiltersChips from "../../components/Filter/AppliedFiltersChips";
import {
  ColumnCustomizationButton,
  COLUMN_CUSTOMIZATION_PAGE_IDS,
  usePageColumnCustomization,
} from "../../components/ColumnCustomization";

const PAGE_SIZE_OPTIONS = [50, 100, 200, 300, 500];
const VIEW_TYPE_OPTIONS = [
  { label: "Performance View", value: "PERFORMANCE" },
  { label: "Funnel View", value: "FUNNEL" },
  { label: "Order View", value: "ORDER" },
  { label: "Aggregate View", value: "AGGREGATE" },
];

const PerformanceAnalysis = (props) => {
  const {
    calendarDate,
    setCalendarDate,
    dateDifference,
    setDateDifference,
    applyCalendar,
    multiCalendarDate,
    clientId,
    setHeaderCalendarHandleComparisonView,
    setHeaderCalendarHideComparisonSwitch,
    refreshCustomSavedReports,
    customSavedReports,
  } = useGlobalContext();

  const dashboardSideBarVisibiltyState = useSelector(
    (state) => state.dashboardData.dashboardSideBarVisibiltyState
  );
  const location = useLocation();

  const allParams = new URLSearchParams(location.search);
  const paramsObject = getSearchParamsObject(allParams);
  const savedReportId = allParams.get("savedReportId");
  const [urlQuery, setUrlQuery] = useState(paramsObject?.urlQuery ?? null);
  const TopXDataConfig = useTopXDataPerformanceConfig();
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  const viewTYPE = allParams.get("viewtype") ?? "PERFORMANCE";
  const [isComparisonView, setisComparisonView] = useState(
    allParams.get("isComparisonView") ?? false
  );
  const [isManualSorting, setIsManualSorting] = useState(false);
  
  const DATE_MEASURES = ["gmv", "order_units", "total_cvr", "total_roas"];
  const isTimeLevelDimensionSelected = () =>
    queryDimensions?.length === 1 &&
    TIME_LEVEL_DIMENSIONS.includes(queryDimensions[0]);

  // decode the urlQuery and parse it into json
  // const previousFiltering = objectoFiltering(paramsObject,"VariantAnalysisTablePPMPlaceholder")
  const [showCustomDateBox, setShowCustomDateBox] = useState(false);

  let startDate = formatDate(multiCalendarDate.selection1.startDate);
  let endDate = formatDate(multiCalendarDate.selection1.endDate);
  let startDatePrevious = formatDate(multiCalendarDate.selection2.startDate);
  let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
  const queryTimeDimensionsFormatted = !isComparisonView
    ? [
        {
          dimension: PlatformWiseKeyMapper[userPlatform]?.date,
          dateRange: [
            formatDate(calendarDate[0].startDate),
            formatDate(calendarDate[0].endDate),
          ],
        },
      ]
    : [
        {
          dimension: PlatformWiseKeyMapper[userPlatform]?.date,
          compareDateRange: [
            [startDate, endDate],
            [startDatePrevious, endDatePrevious],
          ],
        },
      ];

  const { clientAccountId } = useGlobalContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [filterModuleFilters, setFilterModuleFilters] = useState({});
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [showComplexFilter, setShowComplexFilter] = useState(false);

  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const [showPercentage, setShowPercentage] = useState(false); // default false

  const groupByOptionsData = useMemo(
    () => PerformanceAnalysisGroupByOptions[userPlatform] || [],
    [userPlatform]
  );
  const initialGroupByFilter =
    allParams.get("reportType") ??
    groupByOptionsData?.[0]?.value ??
    "";
  const [groupByFilter, setGroupByFilter] = useState(initialGroupByFilter);
  const [customDate, setCustomDate] = useState("last_7d");
  const [newRawData, setNewRawData] = useState([]);
  const [newRawSummaryData, setNewRawSummaryData] = useState({});
  const [summaryDataWithoutFilter, setSummaryDataWithoutFilter] = useState({});
  const [totalProductCount, setTotalProductCount] = useState(0);
  const [inputValue, setInputValue] = useState(""); // immediate UI update
  const [searchValue, setSearchValue] = useState(""); // debounced search
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [downloadLimit, setDownloadLimit] = useState(5000);
  const [isDownloading, setIsDownloading] = useState(false);
  const [selectedBaseUrl, setSelectedBaseUrl] = useState(null);
  const latestRequestIdRef = useRef(0);
  const activeRequestControllerRef = useRef(null);
  const isProcessingUrlQueryRef = useRef(false);
  const processedUrlQueryRef = useRef(null);
  const isClearingSavedReportRef = useRef(false);

  const [queryMeasure, setQueryMeasure] = useState(
    PerformanceAnalysisMeasures[userPlatform]
  );

  const initialQueryDimensions =
    groupByOptionsData?.find((option) => option.value === groupByFilter)
      ?.dimensions ||
    groupByOptionsData?.[0]?.dimensions ||
    [];

  const [queryOrder, setQueryOrder] = useState(
    PlatformWiseQueryOrder[userPlatform]
  );

  const [queryDimensions, setQueryDimensions] = useState(
    initialQueryDimensions
  );
  const [allColumns, setAllColumns] = useState(
    getPerformanceAllColumns(false, queryDimensions) ?? []
  );

  const {
    currentViewType,
    selectedMetricKeys,
    columnCollectionId,
    metricColumns,
    columnCollections,
    visibleTableColumns,
    isSaving: isColumnCustomizationSaving,
    syncFromViewType,
    handleApply: handleApplyColumnCustomization,
    handleSave: handleSaveColumnCustomization,
    handleSaveAs: handleSaveAsColumnCustomization,
    handleRenameView: handleRenameColumnView,
    handleDeleteView: handleDeleteColumnView,
  } = usePageColumnCustomization({
    pageId: COLUMN_CUSTOMIZATION_PAGE_IDS.PERFORMANCE_ANALYSIS,
    allColumns,
    standardViewOptions: VIEW_TYPE_OPTIONS,
    initialViewType: viewTYPE,
    platform: userPlatform,
  });

  const [queryTimeDimensions, setQueryTimeDimensions] = useState(
    queryTimeDimensionsFormatted
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const viewtype = params.get("viewtype");
    const reportType = params.get("reportType");
    const nextUrlQuery = params.get("urlQuery");
    const analysisDimensionsParam = params.get("analysisDimensions");

    syncFromViewType(viewtype ?? "PERFORMANCE");
    const fallbackGroupBy = groupByOptionsData?.[0]?.value ?? "";
    const nextGroupBy =
      reportType && groupByOptionsData?.some((o) => o.value === reportType)
        ? reportType
        : fallbackGroupBy;
    setGroupByFilter(nextGroupBy);
    const nextGroupByDimensions =
      groupByOptionsData?.find((o) => o.value === nextGroupBy)?.dimensions || [];
    const allAllowedDimensions = [
      ...new Set(
        (groupByOptionsData || []).flatMap((option) => option?.dimensions || [])
      ),
    ];
    const parsedSavedDimensions = (analysisDimensionsParam || "")
      .split(",")
      .map((dimension) => dimension?.trim())
      .filter((dimension) => dimension && allAllowedDimensions.includes(dimension));
    const nextDimensions =
      parsedSavedDimensions.length > 0
        ? parsedSavedDimensions
        : nextGroupByDimensions;
    if (nextDimensions.length) {
      setQueryDimensions(nextDimensions);
    }

    if (nextUrlQuery !== urlQuery) {
      setUrlQuery(nextUrlQuery);
    }

    if (!nextUrlQuery) {
      if (urlQuery) {
        isClearingSavedReportRef.current = true;
      }
      processedUrlQueryRef.current = null;
      isProcessingUrlQueryRef.current = false;
      setFilterModuleFilters({});
      setIsFilterApplied(false);
    }
  }, [location?.search, groupByOptionsData, urlQuery]);

  useEffect(() => {
    setIsLoaderVisible(true);
    processedUrlQueryRef.current = null;
    setCurrentPage(1);
  }, [location?.search]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get("start") && queryParams.get("end")) {
      setDate(queryParams.get("start"), queryParams.get("end"));
    }
  }, []);

  const setDate = (currentDate, previousDate) => {
    const dates = {
      startDate: new Date(currentDate),
      endDate: new Date(previousDate),
      key: "selection",
    };
    setDateDifference("Custom");
    setCalendarDate([dates]);
    setQueryTimeDimensions((prev) => {
      let data = [...prev];
      data[0]["dateRange"] = [
        formatDate(dates.startDate),
        formatDate(dates.endDate),
      ];
      return data;
    });
  };

  const handleFilterOutput = (filters, type) => {
    setCurrentPage(1);
    setShowComplexFilter(false);
    if (
      filters?.dimension?.data?.length === 0 &&
      filters?.metrics?.data?.length === 0 &&
      filters?.campaigns?.data?.length === 0 &&
      filters?.topX?.data?.length === 0
    ) {
      setIsFilterApplied(false);
    } else {
      setIsFilterApplied(true);
    }
    handleDataFetch(filters);
    setFilterModuleFilters(filters);
  };

  useEffect(() => {
    if (isComparisonView) {
      let startDate = formatDate(multiCalendarDate.selection1.startDate);
      let endDate = formatDate(multiCalendarDate.selection1.endDate);
      let startDatePrevious = formatDate(
        multiCalendarDate.selection2.startDate
      );
      let endDatePrevious = formatDate(multiCalendarDate.selection2.endDate);
      let apiDateRange = queryTimeDimensions[0]["compareDateRange"];
      if (
        startDate !== apiDateRange[0][0] ||
        endDate !== apiDateRange[0][1] ||
        startDatePrevious !== apiDateRange[1][0] ||
        endDatePrevious !== apiDateRange[1][1]
      ) {
        setIsLoaderVisible(true);
        setQueryTimeDimensions((prev) => {
          let data = [...prev];
          data[0]["compareDateRange"] = [
            [startDate, endDate],
            [startDatePrevious, endDatePrevious],
          ];
          return data;
        });
      }
      window.sessionStorage.setItem("dateDiff", dateDifference);
      setDateDifference("Custom");
    } else if (!isComparisonView) {
      const startDate = formatDate(calendarDate[0].startDate);
      const endDate = formatDate(calendarDate[0].endDate);
      if (
        startDate !== queryTimeDimensions[0]["dateRange"][0] ||
        endDate !== queryTimeDimensions[0]["dateRange"][1]
      ) {
        setIsLoaderVisible(true);
        setQueryTimeDimensions((prev) => {
          let data = [...prev];
          data[0]["dateRange"] = [startDate, endDate];
          return data;
        });
      }
    }
  }, [applyCalendar]);

  async function getProductReportData(
    filter,
    comparisonApi,
    fetchedCustomDate = null,
    requestMeta = {}
  ) {
    try {
      const { signal, requestId } = requestMeta;

      let updatedDateMeasures = [...queryMeasure];
      if (isTimeLevelDimensionSelected()) {
        updatedDateMeasures = [...DATE_MEASURES, ...queryMeasure];
      } else {
        // removing date measures from all columns
        setAllColumns([...allColumns.filter((column) => !DATE_MEASURES.includes(column.key))]);
      }

      let url = "";
      let SummaryUrl = "";

      let baseUrl = `${process.env.REACT_APP_REPORT_API}/client/${clientId}/placement`;
      if (isTimeLevelDimensionSelected()) {
        baseUrl = `${process.env.REACT_APP_REPORT_API}/client/${clientId}/account`;
      }
      if(queryDimensions.includes("keyword")) {
        baseUrl = `${process.env.REACT_APP_REPORT_API}/client/${clientId}/keyword`;
      } else if(queryDimensions.includes("search_term")) {
        baseUrl = `${process.env.REACT_APP_REPORT_API}/client/${clientId}/search-term`;
      }
      setSelectedBaseUrl(baseUrl);

      if (comparisonApi) {
        url = `${baseUrl}:comparison?source=${userPlatform}`;
        SummaryUrl = `${baseUrl}:comparison-summary?source=${userPlatform}`;
      } else {
        url = `${baseUrl}:insights?source=${userPlatform}`;
        SummaryUrl = `${baseUrl}:insights-summary?source=${userPlatform}`;
      }

      const queryData = {
        dimensions: queryDimensions,
        filters: filter,
        extra_filters: {
          type: `${userPlatform}`,
          [PlatformWiseKeyMapper[userPlatform]?.defaultCampaignBackend]:
            filter?.campaigns,
        },
        percentile_filters: transformToTopXArray(filter?.topX) ?? [],
        measures: [...updatedDateMeasures, ...queryDimensions],
        order: isManualSorting ? queryOrder : isTimeLevelDimensionSelected() ? [[queryDimensions[0], "desc"]] : queryOrder,
        date_preset: null,
        timeDimensions: comparisonApi
          ? getComparisonFormatTimeDimension(queryTimeDimensions)
          : queryTimeDimensions,
        offset: (currentPage - 1) * itemsPerPage,
        limit: itemsPerPage,
      };

      const dataToPost = { query: queryData };

      // Prepare query for summary without filters
      let filterForSummaryWithoutFilters = {};
      let tempFilter = JSON.parse(
        JSON.stringify(filterForSummaryWithoutFilters)
      );
      const summaryWithoutFiltersDataToPost = {
        query: {
          ...queryData,
          filters: tempFilter, // empty filter for total summary without filter
          percentile_filters: [],
          measures: queryData.measures.filter((measure) => !TIME_LEVEL_DIMENSIONS.includes(measure)),
        },
      };

      const summaryDataToPost = {
        query: {
          ...queryData,
          measures: queryData.measures.filter((measure) => !TIME_LEVEL_DIMENSIONS.includes(measure)),
        },
      };

      // Fetch all APIs in parallel
      const [summaryData, summaryDataWithoutFilters, data] = await Promise.all([
        // Summary with filters
        axios.post(SummaryUrl, summaryDataToPost, { signal }),
        // Summary without filters
        axios.post(SummaryUrl, summaryWithoutFiltersDataToPost, { signal }),
        // Main data
        axios.post(url, dataToPost, { signal }),
      ]);

      if (requestId !== latestRequestIdRef.current) return;

      // Process summary without filters
      if (summaryDataWithoutFilters?.status === 200) {
        setSummaryDataWithoutFilter(summaryDataWithoutFilters?.data ?? {});
      }

      // Process summary with filters
      let totalCount = 0;
      if (summaryData?.status === 200) {
        totalCount = summaryData?.data?.total_count ?? 0;
        setTotalProductCount(totalCount);
      }

      // Process main data
      if (data?.status === 200) {
        setNewRawData(data?.data?.data ?? []);
        setNewRawSummaryData(summaryData?.data ?? {});
        setTotalPages(Math.ceil(totalCount / itemsPerPage) ?? 1);
      }
    } catch (error) {
      if (axios.isCancel(error) || error?.name === "CanceledError") {
        return;
      }
      console.error(error); // keep normal error logging
      toast.error(
        error?.response?.data?.message ??
          error?.message ??
          "Some unknown error occurred!"
      );
    }
  }

  const executeDataRequest = async (
    filters,
    comparisonApi = isComparisonView,
    fetchedCustomDate = null
  ) => {
    if (activeRequestControllerRef.current) {
      activeRequestControllerRef.current.abort();
    }

    const requestId = latestRequestIdRef.current + 1;
    latestRequestIdRef.current = requestId;
    const controller = new AbortController();
    activeRequestControllerRef.current = controller;

    setIsLoaderVisible(true);
    try {
      await getProductReportData(filters, comparisonApi, fetchedCustomDate, {
        signal: controller.signal,
        requestId,
      });
    } finally {
      if (requestId === latestRequestIdRef.current) {
        setIsLoaderVisible(false);
      }
    }
  };

  const handleDownloadButtonClick = async () => {
    await handleDownloadAllProductData(
      filterModuleFilters,
      isComparisonView,
      null,
      downloadLimit,
      setIsDownloading,
      userPlatform,
      clientId,
      clientAccountId,
      queryDimensions,
      isTimeLevelDimensionSelected() ? [...queryMeasure, ...queryDimensions, ...DATE_MEASURES] : [...queryMeasure, ...queryDimensions],
      isManualSorting ? queryOrder : isTimeLevelDimensionSelected() ? [[queryDimensions[0], "desc"]] : queryOrder,
      queryTimeDimensions,
      false,
      customDate,
      [],
      PlatformWiseKeyMapper,
      transformToTopXArray,
      getComparisonFormatTimeDimension,
      allColumns,
      currentViewType,
      {
        baseUrl: selectedBaseUrl ?? `${process.env.REACT_APP_REPORT_API}/client/${clientId}/placement`,
      },
      {
        visibleColumnKeys: getDataHeads().map((column) => column.key),
      }
    );
  };

  const getSelectedSearchDimensions = () => {
    const selectedColumnKeys = allColumns
      .filter(
        (column) =>
          column?.isDimension && !TIME_LEVEL_DIMENSIONS.includes(column.key)
      )
      .map((column) => column.key);

    const expandedDimensions = selectedColumnKeys.flatMap((key) => {
      const groupOption = groupByOptionsData?.find((option) =>
        option?.dimensions?.includes(key)
      );
      return groupOption?.dimensions || [key];
    });

    return [...new Set(expandedDimensions)].filter(
      (dimension) =>
        !TIME_LEVEL_DIMENSIONS.includes(dimension) &&
        queryDimensions.includes(dimension)
    );
  };

  const applySearchOnFilters = (baseFilter = {}) => {
    const searchText = searchValue?.trim();
    if (!searchText) return baseFilter;

    const searchRuleItems = getSelectedSearchDimensions().map((dimension) => ({
      type: "RULE_ITEM",
      member: dimension,
      operator: "contains",
      values: [searchText],
    }));

    if (!searchRuleItems.length) return baseFilter;

    return ruleItemInjector(
      baseFilter,
      "dimensions",
      defaultDimensions("", searchRuleItems),
      "OR_RULE"
    );
  };

  const handleDataFetch = (moduleFilters, fetchedCustomDate = null) => {

    if ((TIME_LEVEL_DIMENSIONS.includes(groupByFilter) || isTimeLevelDimensionSelected()) && isComparisonView) {
      return;
    }
    setIsLoaderVisible(true);
    const filters = mergeCustomOutputToAPIFiltersFormat(
      moduleFilters?.metrics?.custom_output,
      moduleFilters?.dimension?.custom_output,
      moduleFilters?.campaigns?.custom_output,
      moduleFilters?.topX?.custom_output
    );

    let tempFilter = JSON.parse(JSON.stringify(filters));
    tempFilter = applySearchOnFilters(tempFilter);
    executeDataRequest(tempFilter, isComparisonView, fetchedCustomDate);
  };

  const getDataHeads = () => {
    let dataHeads = visibleTableColumns;
    // Show DATE_MEASURES only when a time-level dimension is selected (date, week, or month)
    const showDateMeasures = isTimeLevelDimensionSelected();
    if (!showDateMeasures) {
      dataHeads = dataHeads.filter(
        (column) => !DATE_MEASURES.includes(column.key)
      );
    }
    return dataHeads;
  };

  useEffect(() => {
    if (isProcessingUrlQueryRef.current) {
      return;
    }

    if (urlQuery && processedUrlQueryRef.current !== urlQuery) {
      processedUrlQueryRef.current = urlQuery;
      handleQueryChange(urlQuery);
      return;
    }

    const effectiveFilters = isClearingSavedReportRef.current
      ? {}
      : filterModuleFilters;
    isClearingSavedReportRef.current = false;
    handleDataFetch(effectiveFilters);
  }, [queryDimensions, queryTimeDimensions, queryOrder, location?.search, urlQuery]);

  useEffect(() => {
    // refetch columns on dimension change
    let updatedColumns = getPerformanceAllColumns(false, queryDimensions);
    setAllColumns(() => [...updatedColumns]);
  }, [queryDimensions]);

  const handleComparisonView = useCallback((isComparison) => {
    // Prevent enabling comparison view if Analysis By is a time-level dimension (date, week, month)
    const isDateSelected = TIME_LEVEL_DIMENSIONS.includes(groupByFilter) || isTimeLevelDimensionSelected();
    if (isComparison && isDateSelected) {
      toast.warning("Comparison view is not available when Analysis By is set to Date, Week, or Month");
      return;
    }
    
    if (isComparison) {
      setQueryTimeDimensions([
        {
          dimension: PlatformWiseKeyMapper[userPlatform]?.date,
          compareDateRange: [
            [startDate, endDate],
            [startDatePrevious, endDatePrevious],
          ],
        },
      ]);
      setIsLoaderVisible(true);
    } else {
      setQueryTimeDimensions([
        {
          dimension: PlatformWiseKeyMapper[userPlatform]?.date,
          dateRange: [
            formatDate(calendarDate[0].startDate),
            formatDate(calendarDate[0].endDate),
          ],
        },
      ]);
      setIsLoaderVisible(true);
    }
    setisComparisonView(isComparison);
  }, [groupByFilter, queryDimensions, userPlatform, startDate, endDate, startDatePrevious, endDatePrevious, calendarDate]);

  // Disable comparison view when Analysis By is set to a time-level dimension (date, week, month)
  useEffect(() => {
    const isDateSelected = TIME_LEVEL_DIMENSIONS.includes(groupByFilter) || isTimeLevelDimensionSelected();
    if (isDateSelected && isComparisonView) {
      // Automatically switch to normal view when date is selected
      handleComparisonView(false);
      // Update URL to remove isComparisonView parameter
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete("isComparisonView");
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }
  }, [groupByFilter, queryDimensions, isComparisonView, handleComparisonView]);

  useEffect(() => {
    if (
      isProcessingUrlQueryRef.current ||
      (urlQuery && processedUrlQueryRef.current !== urlQuery)
    ) {
      return;
    }
    const effectiveFilters = isClearingSavedReportRef.current
      ? {}
      : filterModuleFilters;
    isClearingSavedReportRef.current = false;
    handleDataFetch(effectiveFilters);
  }, [searchValue, searchTrigger, currentPage, itemsPerPage]);

  useEffect(() => {
    return () => {
      if (activeRequestControllerRef.current) {
        activeRequestControllerRef.current.abort();
      }
    };
  }, []);

  const calenderIconRefForCampaignlist = useRef(null);

  const closeCalender = (e) => {
    if (
      calenderIconRefForCampaignlist.current &&
      showCustomDateBox &&
      !calenderIconRefForCampaignlist.current.contains(e.target)
    ) {
      setShowCustomDateBox(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeCalender);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", closeCalender);
    };
  }, [showCustomDateBox]);

  useEffect(() => {
    if (!groupByFilter) return;

    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("reportType", groupByFilter);
    queryParams.set("viewtype", currentViewType);

    const dimensionsParam = (queryDimensions || []).join(",");
    if (dimensionsParam) {
      queryParams.set("analysisDimensions", dimensionsParam);
    } else {
      queryParams.delete("analysisDimensions");
    }

    const newSearch = queryParams.toString();
    const currentSearch = window.location.search.replace(/^\?/, "");
    if (newSearch === currentSearch) return;

    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}?${newSearch}`
    );
  }, [groupByFilter, currentViewType, queryDimensions]);

  useEffect(() => {
    setHeaderCalendarHandleComparisonView(() => handleComparisonView);
    setHeaderCalendarHideComparisonSwitch(groupByFilter === "date" || queryDimensions.includes("date"));
    return () => {
      setHeaderCalendarHandleComparisonView(null);
      setHeaderCalendarHideComparisonSwitch(false);
    };
  }, [setHeaderCalendarHandleComparisonView, setHeaderCalendarHideComparisonSwitch, handleComparisonView]);


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePageLimitChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };


  const handleQueryChange = (urlQuery) => {
    isProcessingUrlQueryRef.current = true;
    const urlQueryFilter = JSON.parse(
      decodeURIComponent(urlQuery ? urlQuery : "{}")
    );
    let filterCustomFormat =
      reverseMergeAPIFiltersToFilterModuleFormat(urlQueryFilter);
    if (
      filterCustomFormat?.metrics?.custom_output ||
      filterCustomFormat?.dimension?.custom_output ||
      filterCustomFormat?.campaigns?.custom_output
    ) {
      setIsFilterApplied(true);
    }
    // handleDataFetch(filterCustomFormat);
    setFilterModuleFilters((prev) => {
      return JSON.parse(JSON.stringify(filterCustomFormat));
    });
    handleDataFetch(filterCustomFormat);
    setTimeout(() => {
      isProcessingUrlQueryRef.current = false;
    }, 0);
    return filterCustomFormat;
  };

  const handleExtraDimensionChange = (dimensions = [], action) => {
    setIsManualSorting(false);
    if (action === "add") {
      if (allColumns.filter((column) => column?.isDimension).length >= 4) {
        return;
      }
      setQueryDimensions((prev) => {
        const uniqueDimensions = [...new Set([...(prev || []), ...(dimensions || [])])];
        return uniqueDimensions;
      });
    } else if (action === "remove") {
      setQueryDimensions((prev) =>
        prev.filter((dimension) => !dimensions.includes(dimension))
      );
    }
  };

  function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const getPlaceholderText = () => {
    const labels = allColumns
      .filter(
        (column) =>
          column?.isDimension && !TIME_LEVEL_DIMENSIONS.includes(column.key)
      )
      .map((column) => column.shortTitle)
      .filter(Boolean);
    const placeholderText = `Search ${[...new Set(labels)].join(", ")}`;
    return placeholderText;
  }

  const currentSavedReport = (customSavedReports ?? []).find(
    (report) => report?.id === savedReportId
  );

  const handleSaveCustomView = async (reportName) => {
    const trimmedName = reportName?.trim();
    if (!trimmedName) return;

    const cubeFilters = mergeCustomOutputToAPIFiltersFormat(
      filterModuleFilters?.metrics?.custom_output,
      filterModuleFilters?.dimension?.custom_output,
      filterModuleFilters?.campaigns?.custom_output,
      filterModuleFilters?.topX?.custom_output
    );

    try {
      const performanceReportKey = getCustomReportKeyByPage(
        userPlatform,
        "performance"
      );
      const pageUrlParams = new URLSearchParams({
        reportType: groupByFilter,
        viewtype: currentViewType,
        analysisDimensions: (queryDimensions || []).join(","),
      });
      await saveCustomReportByKey(clientId, performanceReportKey, {
        reportName: trimmedName,
        cubeFilters,
        pageURL: `performance-analysis?${pageUrlParams.toString()}`,
      }, userPlatform);
      await refreshCustomSavedReports?.();
      toast.success("Custom report saved successfully");
    } catch (error) {
      toast.error(
        error?.response?.data?.message ??
          error?.message ??
          "Unable to save custom report"
      );
    }
  };

  const handleUpdateCustomView = async (reportId) => {
    if (!reportId) return;
    const cubeFilters = mergeCustomOutputToAPIFiltersFormat(
      filterModuleFilters?.metrics?.custom_output,
      filterModuleFilters?.dimension?.custom_output,
      filterModuleFilters?.campaigns?.custom_output,
      filterModuleFilters?.topX?.custom_output
    );
    try {
      const performanceReportKey = getCustomReportKeyByPage(
        userPlatform,
        "performance"
      );
      const pageUrlParams = new URLSearchParams({
        reportType: groupByFilter,
        viewtype: currentViewType,
        analysisDimensions: (queryDimensions || []).join(","),
      });
      await updateCustomReportById(
        clientId,
        performanceReportKey,
        reportId,
        {
          cubeFilters,
          pageURL: `performance-analysis?${pageUrlParams.toString()}`,
          reportName: currentSavedReport?.reportName ?? "Saved Report",
        },
        userPlatform
      );
      await refreshCustomSavedReports?.();
      toast.success("Custom report updated successfully");
    } catch (error) {
      toast.error(
        error?.response?.data?.message ??
          error?.message ??
          "Unable to update custom report"
      );
    }
  };

  const FilterComponent = (
    <ComplexFilterWidget
      key={`performance_analysis_page_${showComplexFilter}`}
      config={{
        campaigns: FiltersCampaignDataPerformance[userPlatform],
        measure: FiltersMeasuresDataPerformance[userPlatform],
        dimension: FiltersDimensionDataPerformance[userPlatform],
        topXConfig: TopXDataConfig,
      }}
      campaignFilter={false}
      showDimensionFilter={false}
      filters={filterModuleFilters}
      showPopupModal={showComplexFilter}
      setShowPopupModal={setShowComplexFilter}
      output={handleFilterOutput}
      prefixMember={""}
      type="page"
      sidebar={true}
      default={"metrics"}
      page={"overlay"}
      isAppliedCallback={() => {}}
      summary={"always"}
      narrowFilters={true}
      summaryOutput={(e) => {}}
      calloutTitle="Select your filters"
      calloutContent="+ Add Filter"
      hideFilterSummary={true}
      // calloutDescription="Add new attributes at campaign level to determine campaign funnel"
    />
  );

  useEffect(() => {
    const init = async () => {
      const precessedDimensionData = await processFields(
        FiltersDimensionDataPerformance[userPlatform].fields,
        clientId,
        []
      );
      FiltersDimensionDataPerformance[userPlatform].fields =
        precessedDimensionData;
      const precessedMeasuresData = await processFields(
        FiltersMeasuresDataPerformance[userPlatform].fields,
        clientId,
        []
      );
      FiltersMeasuresDataPerformance[userPlatform].fields = precessedMeasuresData;
      const precessedAmazonData = await processFields(
        FiltersCampaignDataPerformance[userPlatform].fields,
        clientId,
        []
      );
      FiltersCampaignDataPerformance[userPlatform].fields = precessedAmazonData;
    };
    init();
  }, [clientId]);

  return (
    <div
      key={`performance-analysis-${savedReportId ?? "default"}`}
      className={
        dashboardSideBarVisibiltyState
          ? "main-content-container-onopen-mode"
          : "main-content-container-oncolapse-mode"
      }
      id="main-box"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Typography variant="h6" fontWeight={600}>
              Performance Analysis
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            This page shows key performance metrics for your{" "}
            {capitalizeFirstLetter(userPlatform)} products.
          </Typography>
        </Box>
      </Box>

      <div>
        {/* Filter Header*/}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 1,
            mb: 2,
            position: "relative",
            alignItems: "center",
          }}
        >
          {/* Group By Dropdown */}
          <Autocomplete
            options={groupByOptionsData}
            disableClearable
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Analysis by"
                variant="outlined"
                size="small"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontSize: "14px",
                    color: "#333333",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#333333", // keep same color when focused
                  },
                  "& .MuiInputBase-root": {
                    height: "36px",
                    fontSize: "12px !important",
                    color: "#333333",
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "12px !important",
                    color: "#333333",
                    padding: "6px 8px",
                  },
                }}
              />
            )}
            value={
              groupByOptionsData?.find((o) => o.value === groupByFilter) || null
            }
            onChange={(event, selectedOption) => {
              if (selectedOption) {
                setQueryDimensions([...selectedOption.dimensions]);
                setInputValue("");
                setCurrentPage(1);
                setGroupByFilter(selectedOption.value);
                setIsManualSorting(false);
                
              }
            }}
            size="small"
            sx={{
              minWidth: "180px",
              "& .MuiAutocomplete-inputRoot": {
                fontSize: "12px",
                color: "#333333",
              },
              "& .MuiAutocomplete-input": {
                fontSize: "12px",
                color: "#333333",
              },
              "& .MuiSvgIcon-root": {
                color: "#333333",
              },
            }}
            slotProps={{
              listbox: {
                sx: {
                  maxHeight: 250,
                  overflow: "auto",
                  fontSize: "12px",
                  "& .MuiAutocomplete-option": {
                    fontSize: "12px",
                    color: "#333333",
                    padding: "6px 12px",
                    "&:hover": { backgroundColor: "#EDEDED" },
                  },
                },
              },
            }}
          />

          {/* Search Box */}
          <TextField
            size="small"
            // it's showing comma in the last of the placeholder fix it
            // remove the last comma if there is one
            placeholder={getPlaceholderText()}
            variant="outlined"
            disabled={isTimeLevelDimensionSelected()}
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setCurrentPage(1);
                setSearchValue(e.target.value);
                setSearchTrigger((prev) => prev + 1);
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "16px", color: "#333333" }} />
                </InputAdornment>
              ),
              endAdornment: searchValue && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      setSearchValue("");
                      setInputValue("");
                    }}
                    edge="end"
                  >
                    <CloseIcon sx={{ fontSize: "16px", color: "#333333" }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              flexGrow: 1,
              "& .MuiInputBase-root": {
                height: "36px",
                fontSize: "12px",
                color: "#333333",
                "&.Mui-disabled": {
                  backgroundColor: "grey.100",
                  color: "#333333",
                },
              },
              "& .MuiInputBase-input": {
                fontSize: "12px",
                color: "#333333",
                padding: "6px 4px",
                "&.Mui-disabled": {
                  backgroundColor: "grey.100",
                  color: "#333333",
                  cursor: "not-allowed",
                },
              },
              "& .MuiInputBase-input::placeholder": {
                fontSize: "12px",
                color: "#000000",
                opacity: 0.6,
                "&.Mui-disabled": {
                  backgroundColor: "grey.100",
                  color: "#333333",
                  cursor: "not-allowed",
                },
              },
            }}
          />

          <ColumnCustomizationButton
            collections={columnCollections}
            columns={metricColumns}
            activeCollectionId={columnCollectionId}
            selectedColumnKeys={selectedMetricKeys}
            onApply={handleApplyColumnCustomization}
            onSave={handleSaveColumnCustomization}
            onSaveAs={handleSaveAsColumnCustomization}
            onRenameView={handleRenameColumnView}
            onDeleteView={handleDeleteColumnView}
            saving={isColumnCustomizationSaving}
          />

          <ToggleButton
            value="filters"
            selected={showComplexFilter}
            onChange={() => setShowComplexFilter(!showComplexFilter)}
            sx={{
              height: "36px",
              borderRadius: 1,
              px: 1.5,
              borderColor: showComplexFilter ? "grey.700" : "grey.400",
              backgroundColor: showComplexFilter ? "grey.100" : "white",
              color: "#333333",
              fontSize: "12px",
              fontWeight: 500,
              textTransform: "none",
              "&:hover": {
                borderColor: "grey.700",
                backgroundColor: showComplexFilter ? "grey.200" : "grey.50",
              },
              "& .MuiTypography-root": {
                fontSize: "12px",
                color: "#333333",
              },
              "& svg": {
                color: "#333333",
              },
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Badge
                overlap="circular"
                variant="dot"
                invisible={!isFilterApplied}
                sx={{
                  "& .MuiBadge-badge": {
                    bgcolor: isFilterApplied ? "primary.main" : "transparent",
                  },
                }}
              >
                {showComplexFilter ? (
                  <FilterAlt fontSize="small" />
                ) : (
                  <FilterAltOutlined fontSize="small" />
                )}
              </Badge>
              <Typography fontWeight={500}>Filters</Typography>
              {showComplexFilter ? (
                <ArrowDropUp fontSize="small" />
              ) : (
                <ArrowDropDown fontSize="small" />
              )}
            </Stack>
          </ToggleButton>

          {/* download button */}
          <Tooltip
            title="We will download maximum 5000 records, apply filters accordingly"
            arrow
            placement="top"
          >
            <span>
              <IconButton
                onClick={handleDownloadButtonClick}
                disabled={isDownloading}
                sx={{
                  border: "1px solid",
                  borderColor: "grey.400",
                  borderRadius: 1,
                  color: "#333333",
                  "&:hover": {
                    borderColor: "grey.700",
                    backgroundColor: "grey.50",
                  },
                  width: 36,
                  height: 36,
                  position: "relative",
                }}
              >
                {isDownloading ? (
                  <CircularProgress
                    size={18}
                    thickness={5}
                    sx={{
                      color: "grey.600",
                    }}
                  />
                ) : (
                  <FileDownloadOutlined sx={{ fontSize: 24 }} />
                )}
              </IconButton>
            </span>
          </Tooltip>

          {!isComparisonView && (
            <FormControlLabel
              label="Include %"
              labelPlacement="start"
              control={
                <Switch
                  size="small"
                  checked={showPercentage}
                  onChange={(e) => setShowPercentage(e.target.checked)}
                />
              }
              sx={{
                borderLeft: "1px solid #ddd", // separator line
                pl: 0.8,
                ml: 0.2,
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  color: "#333333",
                  paddingLeft: "4px",
                },
                "& .MuiSwitch-root": {
                  padding: "6px 8px",
                },
              }}
            />
          )}
        </Box>

        {showComplexFilter && FilterComponent}
        <AppliedFiltersChips
          filters={filterModuleFilters}
          config={{
            campaigns: FiltersCampaignDataPerformance[userPlatform],
            measure: FiltersMeasuresDataPerformance[userPlatform],
            dimension: FiltersDimensionDataPerformance[userPlatform],
            topXConfig: TopXDataConfig,
          }}
          onChange={handleFilterOutput}
          onSaveReport={handleSaveCustomView}
          onUpdateReport={handleUpdateCustomView}
          currentSavedReport={currentSavedReport}
        />
        <ProductAnalyticsTable
          key={ isManualSorting ? "performance_analysis_page_manual_sort" : isTimeLevelDimensionSelected() ? "performance_analysis_page_date" : "performance_analysis_page"}
          dataHeads={getDataHeads()}
          dataBody={newRawData}
          isLoading={isLoaderVisible}
          orderByData={isManualSorting ? queryOrder : isTimeLevelDimensionSelected() ? [[queryDimensions[0], "desc"]] : queryOrder}
          onSortClick={useCallback(
            (key, order) => {
              setIsManualSorting(true);
              setCurrentPage(1);
              setQueryOrder([[key, order]]);
            },
            [setQueryOrder,setIsManualSorting]
          )}
          summaryData={newRawSummaryData}
          showPercentage={showPercentage}
          summaryDataWithoutFilter={summaryDataWithoutFilter}
          isComparisonView={isComparisonView}
          groupByOptionsData={groupByOptionsData?.filter((option) => {
            if (option.value === groupByFilter) return false;
            if (
              option?.disabledDimensions?.some((dimension) =>
                queryDimensions.includes(dimension)
              )
            ) {
              return false;
            }
            if (!option?.dimensions?.length) return false;

            const isAlreadyAdded = option.dimensions.every((dimension) =>
              queryDimensions.includes(dimension)
            );
            return !isAlreadyAdded;
          })}
          onExtraGroupByChange={handleExtraDimensionChange}
          showGroupByPlusIcon={
            allColumns.filter((column) => column?.isDimension).length < 4 &&
            isPlatformMatch(["flipkart", "myntra"])
          }
        />
        {(totalProductCount > 0 || currentPage > 1) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              py: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#4f5366",
              }}
            >
              <Typography variant="body2" sx={{ fontSize: "12px" }}>
                Page Size
              </Typography>
              <FormControl size="small" sx={{ minWidth: 80 }}>
                <Select
                  value={itemsPerPage}
                  onChange={handlePageLimitChange}
                  disabled={isLoaderVisible}
                  sx={{
                    height: 36,
                    fontSize: "12px",
                    color: "#333333",
                  }}
                  MenuProps={{ disableScrollLock: true }}
                >
                  {PAGE_SIZE_OPTIONS.map((option) => (
                    <MenuItem
                      key={option}
                      value={option}
                      sx={{ fontSize: "12px" }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <CustomPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              lazyLoading={isLoaderVisible}
              hidePagination={!totalPages || totalPages === 0}
              totalItems={totalProductCount}
              itemsPerPage={itemsPerPage}
            />
          </Box>
        )}
      </div>
    </div>
  );
};

export default PerformanceAnalysis;
